import type React from 'react';

import { Button } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

export const SubmitButton: React.FC<{
	hasValidationErrors: boolean;
	loading: boolean;
}> = ({ hasValidationErrors, loading }) => {
	return (
		<Button
			type="submit"
			data-testid="submit"
			data-qa="submit"
			disabled={hasValidationErrors || loading}
			className="w-full md:w-fit"
			variant="primary"
			size="small"
		>
			<Translate value="corgi.petition.starter_dashboard_v2.post_an_update.form.submit_button" />
		</Button>
	);
};
